import React from 'react';
import Path from '../../images/request-16.png';

const Icon = props => (
    <div>
        <img src={props.src && props.src.length > 0 ? props.src : Path}  
        style={props.style != null ? props.style : {  }}
        title={props.title != null ? props.title : "Request"}/>
    </div>
);

export default Icon;
